interface Params {
  activeIndex: number
  loadedCount: number
  totalCount?: number
  hasMorePages: boolean
}

interface TicketScrollIndicatorState {
  isVisible: boolean
  progress: number
  thumbRatio: number
}

export const getTicketScrollIndicatorState = ({
  activeIndex,
  loadedCount,
  totalCount,
  hasMorePages,
}: Params): TicketScrollIndicatorState => {
  const normalizedLoadedCount = Math.max(loadedCount, 0)
  const normalizedActiveIndex = Math.min(
    Math.max(activeIndex, 0),
    Math.max(normalizedLoadedCount - 1, 0),
  )
  const hasKnownTotal =
    totalCount !== undefined && totalCount >= normalizedLoadedCount
  const count = hasKnownTotal ? totalCount : normalizedLoadedCount

  return {
    isVisible: count > 1 || hasMorePages,
    progress: count > 1 ? normalizedActiveIndex / (count - 1) : 0,
    thumbRatio: count > 0 ? 1 / count : 1,
  }
}
